/**
 * SA-947 (spec P12): which step of the Connect dialog a status read is at,
 * and how often to read it again. Pure.
 */
import type { WahaSourceRead } from '@/services/mailboxes'

export type ConnectPhase = 'starting' | 'link' | 'choose' | 'bound' | 'failed' | 'stopped'

const ENDED = new Set(['FAILED', 'MISSING'])

export function connectPhase(read: WahaSourceRead | undefined): ConnectPhase {
  if (!read) return 'starting'
  if (read.status === 'reauth_required' || (read.session_status !== null && ENDED.has(read.session_status))) {
    return 'failed'
  }
  // Before WORKING: a reconnect keeps the bound group but must link again.
  if (read.session_status === 'SCAN_QR_CODE') return 'link'
  // A paused row's session is stopped on purpose; on any other row STOPPED is a
  // WAHA restart (the pilot saw it), so keep waiting rather than send the person
  // to a Resume their row does not offer.
  if (read.session_status === 'STOPPED') return read.status === 'paused' ? 'stopped' : 'starting'
  if (read.session_status === 'WORKING') return read.group_id ? 'bound' : 'choose'
  return 'starting'
}

/** Every 3 s until there is nothing left to wait for. */
export function statusInterval(read: WahaSourceRead | undefined): number | false {
  const phase = connectPhase(read)
  return phase === 'bound' || phase === 'failed' || phase === 'stopped' ? false : 3_000
}
